// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.report-buttons[data-v-4d4fa832] {\n  background-color: rgb(245, 245, 245);\n  width: 215px;\n  height: 180px;\n  display: inline-grid;\n}\n.report-flex[data-v-4d4fa832] {\n  text-align: center;\n  min-width: 215px;\n}\n.plus-button[data-v-4d4fa832] {\n  position: relative;\n  right: 15px;\n  top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
